var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M14 1H1v8.386h7.172V12l2.938-2.614H14z","stroke":"#757272","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }